exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhtml, body {\n  height: 100% !important;\n  background-color: white !important;\n}\n.clearfix::after, .cf::after {\n  content: ' ';\n  display: block;\n  clear: both;\n}\n.options-button {\n  background-color: #822023;\n  border: 1px solid #822023;\n}\n.options-button:hover {\n    opacity: .9;\n    cursor: pointer;\n}\n.generic-link {\n  cursor: pointer;\n}\n.form-control.error {\n  border-color: #d9534f;\n}\n.b-dropdown-form {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\nbody {\n  font-family: 'Open Sans', sans-serif;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09aad170","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 658
// module chunks = 1